import { render, staticRenderFns } from "./invoiceValueGroups.vue?vue&type=template&id=f40abd9a&"
import script from "./invoiceValueGroups.vue?vue&type=script&lang=js&"
export * from "./invoiceValueGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports